import { z } from 'zod';
import { REGISTRATION_MAX_LENGTH } from '../../utils/constants';
import { emailValidator, passwordValidator } from '../../utils/common';
import { EducationLevelSchema } from '../education-level/educationLevelSchema';
export const RegisterUserSchema = z.object({
    firstName: z.string().min(1, 'REQUIRED_INPUT').max(REGISTRATION_MAX_LENGTH),
    lastName: z.string().min(1, 'REQUIRED_INPUT').max(REGISTRATION_MAX_LENGTH),
    email: emailValidator,
    password: passwordValidator,
    educationLevel: EducationLevelSchema.optional(),
    address: z.string().max(REGISTRATION_MAX_LENGTH).optional()
});
//# sourceMappingURL=registerUserSchema.js.map